import React, { useState, useEffect } from 'react';
import { Tab, Tabs, Form, InputGroup, Button } from 'react-bootstrap';
import ListItem from '../../componets/ListItem';
import './opportunities.css';
import '../examinations/result.css';
import { Download as DownloadIcon, Search } from 'react-feather';
import { useQuery, gql } from '@apollo/client';

const GET_OPPORTUNITIES = gql`
  query {
    opportunities(pagination: { limit: 100 }) {
      data {
        attributes {
          opportunity_type
          opportunities(pagination: { limit: 100 }, sort: "year:desc") {
            year
            file {
              description
              closing_date
              file {
                data {
                  attributes {
                    name
                    url
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;

const Opportunities = () => {
  const opportunitiesData = useQuery(GET_OPPORTUNITIES);
  const opportunities = opportunitiesData?.data;

  const year = new Date().getFullYear();
  console.log(opportunities);
  const [searchTerm, setSearchTerm] = useState('');
  const [activeType, setActiveType] = useState(null);
  const [activeYears, setActiveYears] = useState({}); // { [type]: year }
  const [currentPages, setCurrentPages] = useState({}); // { [`type-year`]: number }
  const ITEMS_PER_PAGE = 9;

  // Initialize default activeType when data loads
  useEffect(() => {
    if (!activeType) {
      const firstType = opportunities?.opportunities?.data?.[0]?.attributes?.opportunity_type?.toLowerCase();
      if (firstType) setActiveType(firstType);
    }
  }, [activeType, opportunities]);

  // Initialize default active year per type when data loads
  useEffect(() => {
    const types = opportunities?.opportunities?.data || [];
    if (types.length === 0) return;
    const updated = { ...activeYears };
    let changed = false;
    types.forEach(t => {
      const typeKey = t?.attributes?.opportunity_type?.toLowerCase();
      if (!typeKey) return;
      if (!updated[typeKey]) {
        const years = (t?.attributes?.opportunities || [])
          .map(e => e.year)
          .filter(Boolean)
          .sort()
          .reverse();
        if (years[0]) {
          updated[typeKey] = years[0];
          changed = true;
        }
      }
    });
    if (changed) setActiveYears(updated);
  }, [opportunities]);

  return (
    <div className="results-dashboard">
      {/* Header Banner (match Syllabus) */}
      <div
        className="main-banner"
        style={{
          background: 'url(./images/banner/banner1.png) center top',
        }}
      >
        <div className="container px-md-0">
          <h2>
            <span>Opportunities</span>
          </h2>
        </div>
      </div>
      

      {/* Breadcrumb */}
      <div className="breadcrumb">
        <div className="container">
          <ul className="list-unstyled list-inline">
            <li className="list-inline-item">
              <a href="/home">Home</a>
            </li>
            <li className="list-inline-item active">Opportunities</li>
          </ul>
        </div>
      </div>


      <div className="container py-4">
        {/* Search Bar (matches Syllabus) */}
        <div className="search-container mb-4">
          <Form onSubmit={(e) => e.preventDefault()}>
            <InputGroup className="search-input-group">
              <InputGroup.Text className="search-icon">
                <Search size={18} />
              </InputGroup.Text>
              <Form.Control
                type="text"
                placeholder="Search opportunities by description or year..."
                value={searchTerm}
                onChange={(e) => { setSearchTerm(e.target.value); setCurrentPages({}); }}
                className="search-input"
              />
              {searchTerm && (
                <Button 
                  variant="outline-secondary" 
                  onClick={() => setSearchTerm('')}
                  className="clear-search"
                >
                  Clear
                </Button>
              )}
            </InputGroup>
          </Form>
        </div>
        <Tabs
          activeKey={activeType || (opportunities?.opportunities?.data?.[0]?.attributes?.opportunity_type.toLowerCase())}
          onSelect={(k) => { setActiveType(k); setCurrentPages({}); }}
          id="uncontrolled-tab-example"
          className="mb-3 justify-content-center"
        >
          {opportunities?.opportunities?.data?.map((opportunity, key) => (
            <Tab
              eventKey={opportunity?.attributes?.opportunity_type.toLowerCase()}
              title={opportunity?.attributes?.opportunity_type}
              key={key}
            >
              {(() => {
                const typeKey = opportunity?.attributes?.opportunity_type.toLowerCase();
                const entries = (opportunity?.attributes?.opportunities || []);
                const years = entries.map(e => e.year).filter(Boolean).sort().reverse();

                const activeY = activeYears[typeKey] || years[0];

                const pageKey = `${typeKey}-${activeY}`;
                const page = currentPages[pageKey] || 1;

                const yearEntry = entries.find(e => e.year === activeY) || { file: [] };
                const filteredFiles = (yearEntry.file || []).filter((f) => {
                  if (!searchTerm) return true;
                  const s = searchTerm.toLowerCase();
                  const desc = (f?.description || '').toLowerCase();
                  const yr = String(activeY || '').toLowerCase();
                  return desc.includes(s) || yr.includes(s);
                });

                const total = filteredFiles.length;
                const totalPages = Math.ceil(total / ITEMS_PER_PAGE) || 1;
                const pageItems = filteredFiles.slice((page - 1) * ITEMS_PER_PAGE, page * ITEMS_PER_PAGE);

                return (
                  <div>
                    {/* Year Tabs */}
                    {years.length > 0 && (
                      <Tabs
                        activeKey={activeY}
                        onSelect={(y) => { setActiveYears(prev => ({ ...prev, [typeKey]: y })); setCurrentPages(prev => ({ ...prev, [pageKey]: 1 })); }}
                        className="mb-4 year-tabs"
                        variant="pills"
                      >
                        {years.map((y) => (
                          <Tab key={y} eventKey={y} title={`${y}`} />
                        ))}
                      </Tabs>
                    )}

                    {/* Grid */}
                    <div className="results-grid">
                      {pageItems.map((name, idx) => (
                        <div key={idx} className="result-card">
                          <div className="card-icon">
                            <DownloadIcon size={20} />
                          </div>
                          <div className="card-content">
                            <h3>{name.description || 'Document'}</h3>
                            <div className="card-meta">
                              <span className="meta-item">Year: {activeY}</span>
                              {name?.closing_date && (
                                <span className="meta-item">Closes: {name?.closing_date}</span>
                              )}
                            </div>
                          </div>
                          <a
                            href={`${process.env.REACT_APP_API_URL}${name?.file?.data?.attributes?.url}`}
                            className="download-btn"
                            target="_blank"
                            rel="noopener noreferrer"
                            download
                          >
                            <DownloadIcon size={16} className="me-1" /> Download
                          </a>
                        </div>
                      ))}
                      {filteredFiles.length === 0 && (
                        <div className="no-results">No opportunities match your search criteria.</div>
                      )}
                    </div>

                    {/* Pagination */}
                    {filteredFiles.length > 0 && totalPages > 1 && (
                      <div className="pagination-container mt-4">
                        <button
                          className="btn btn-outline-primary pagination-btn"
                          onClick={() => setCurrentPages(prev => ({ ...prev, [pageKey]: Math.max(1, page - 1) }))}
                          disabled={page === 1}
                        >
                          Previous
                        </button>
                        <div className="page-info">Page {page} of {totalPages}</div>
                        <button
                          className="btn btn-outline-primary pagination-btn"
                          onClick={() => setCurrentPages(prev => ({ ...prev, [pageKey]: Math.min(totalPages, page + 1) }))}
                          disabled={page === totalPages}
                        >
                          Next
                        </button>
                      </div>
                    )}
                  </div>
                );
              })()}
            </Tab>
          ))}
        </Tabs>
      </div>
    </div>
  );
};

export default Opportunities;
